import { Task, TaskStatus } from "../../types";
import { DreamcoinResponse } from "./types/dreamcoin";

export class DreamcoinClickAdapter {
  static adaptTasks(
    response: DreamcoinResponse,
    statusResponse?: DreamcoinResponse
  ): Task[] {
    console.log("🔄 DreamcoinClickAdapter.adaptTasks - start", {
      response,
      statusResponse,
    });

    if (
      !response ||
      !response.tasks ||
      !Array.isArray(response.tasks) ||
      response.tasks.length === 0
    ) {
      console.log("⚠️ DreamcoinClickAdapter: Нет доступных заданий");
      return [];
    }

    // Фильтруем только задания типа "partner-click"
    const clickTasks = response.tasks.filter(
      (task) => task.type === "partner-click"
    );

    if (clickTasks.length === 0) {
      console.log("⚠️ DreamcoinClickAdapter: Нет заданий типа partner-click");
      return [];
    }

    return clickTasks.map((task) => {
      // Определяем статус задания
      let status: TaskStatus = "NOT_STARTED";

      switch (task.status) {
        case "DONE":
          status = "DONE";
          break;
        case "CLAIMED":
          status = "CLAIMED";
          break;
        case "IN_PROGRESS":
          status = "IN_PROGRESS";
          break;
        case "NOT_STARTED":
        default:
          status = "NOT_STARTED";
      }

      // Если прогресс пользователя равен целевому, но статус не DONE или CLAIMED,
      // устанавливаем статус DONE
      if (task.user_progress >= task.target_progress && status !== "CLAIMED") {
        status = "DONE";
      }

      // Получаем информацию о награде
      const rewardTickets = task.rewards.find(
        (reward) => reward.type === "tickets"
      );
      const rewardDc = task.rewards.find((reward) => reward.type === "dc");

      return {
        id: task.id,
        title: task.name,
        description: task.partner.name,
        icon: task.icon,
        buttonText:
          task.partner.resource_type === "channel"
            ? "Подписаться"
            : "Выполнить",
        rewards: {
          tickets: rewardTickets?.amount || 0,
          dc: rewardDc?.amount || 0,
        },
        status,
        provider: "DREAMCOIN_CLICK",
        link: task.partner.link,
        type: "click",
        responseType: task.partner.resource_type,
      };
    });
  }
}
